import * as React from "react";
import { Slide, styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { MobileView } from "../util/aKaunGeneralUtil";
import CloseIconButton from "fe-common/ui/icons/closeIconButton";
import { bottomNavigationZIndex } from "fe-common/ui/stacking";

//region [[ Styles ]]

const InstallAppPopoverViewContainer = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  color: KahunColorMap.Primary,
  fontWeight: 300,
  transition: "height 0.5s ease-out",
  boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.1)",
  padding: "18px 25%",
  borderTopRightRadius: "14px",
  borderTopLeftRadius: "14px",
  position: "absolute",
  bottom: "0",
  flexFlow: "column",
  width: "100%",
  display: "flex",
  height: "500px",
  zIndex: bottomNavigationZIndex + 1,
  [theme.breakpoints.down(MobileView)]: {
    padding: "18px",
    height: "186px",
  },
}));

const IntroText = styled("div")({
  padding: "12px 20px",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  maxWidth: "1400px",
  fontSize: "14px",
});

const IntroTextTitle = styled("div")({
  color: KahunColorMap.Primary,
  fontWeight: 700,
  fontSize: "17px",
});

const ActionsPanel = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px",
  [theme.breakpoints.down(MobileView)]: {
    padding: "6px",
  },
}));

const CloseButton = styled(CloseIconButton)({
  right: 0,
  left: "auto",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface InstallAppPopoverViewProps {
  className?: string;
  visible: boolean;
  onClose: () => void;
  titleText: string;
  contentText: string;
  children?: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InstalPopoverView = ({ ...props }: InstallAppPopoverViewProps) => {
  return (
    <Slide in={props.visible} mountOnEnter unmountOnExit direction={"up"}>
      <InstallAppPopoverViewContainer className={props.className}>
        <CloseButton onClick={props.onClose} />
        <IntroText>
          <IntroTextTitle>{props.titleText}</IntroTextTitle>
          {props.contentText}
        </IntroText>
        <ActionsPanel>{props.children}</ActionsPanel>
      </InstallAppPopoverViewContainer>
    </Slide>
  );
};
